import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-755d2512"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule-container" }
const _hoisted_2 = { class: "schedule-header" }
const _hoisted_3 = { class: "schedule-body" }
const _hoisted_4 = { class: "schedule-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainHeaderSortMenu = _resolveComponent("MainHeaderSortMenu")!
  const _component_ScheduleDayMenuButtons = _resolveComponent("ScheduleDayMenuButtons")!
  const _component_NoResults = _resolveComponent("NoResults")!
  const _component_SeparatorBar = _resolveComponent("SeparatorBar")!
  const _component_ScheduleByPlaceGrid = _resolveComponent("ScheduleByPlaceGrid")!
  const _component_ScheduleByHourGrid = _resolveComponent("ScheduleByHourGrid")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_component_MainHeader, {
        guestTypes: _ctx.guestType,
        programs: _ctx.programs,
        route: { name: 'main', type: 'type', id: 'id' },
        text: this.$store.state.language === 'fr' ? 'Accueil' : 'Home',
        showSelect: false
      }, null, 8, ["guestTypes", "programs", "text"]),
      _createVNode(_component_MainHeaderSortMenu, {
        category: 
          this.store.state.language === 'fr'
            ? ['par lieu', 'par heure']
            : ['by place', 'by hour']
        ,
        selectItems: _ctx.tags,
        route: "schedule"
      }, null, 8, ["category", "selectItems"]),
      _createVNode(_component_ScheduleDayMenuButtons, {
        text: _ctx.sortedDays()
      }, null, 8, ["text"])
    ]),
    _createElementVNode("main", null, [
      _withDirectives(_createVNode(_component_NoResults, null, null, 512), [
        [_vShow, _ctx.noResults()]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.places, (place) => {
        return _withDirectives((_openBlock(), _createElementBlock("section", {
          key: place._id,
          ref_for: true,
          ref: "displayed0"
        }, [
          _withDirectives(_createVNode(_component_SeparatorBar, {
            id: _ctx.index,
            text: place.name
          }, null, 8, ["id", "text"]), [
            [_vShow, _ctx.filteredEventsPlace(place._id)]
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ScheduleByPlaceGrid, {
              placeId: place._id
            }, null, 8, ["placeId"])
          ])
        ])), [
          [_vShow, _ctx.$store.state.activeDayMenu.menu === 0]
        ])
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterHours(), (hour) => {
        return _withDirectives((_openBlock(), _createElementBlock("section", {
          key: hour,
          ref_for: true,
          ref: "displayed1"
        }, [
          _withDirectives(_createVNode(_component_SeparatorBar, {
            id: hour,
            text: `${new Date(hour).getHours()}:00`
          }, null, 8, ["id", "text"]), [
            [_vShow, _ctx.filterEventsHour(hour)]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ScheduleByHourGrid, { hour: hour }, null, 8, ["hour"])
          ])
        ])), [
          [_vShow, _ctx.$store.state.activeDayMenu.menu === 1]
        ])
      }), 128))
    ])
  ]))
}